import { useContext } from 'react';

import AppElement from './AppElement';

export default function useAppElement() {
  return useContext(AppElement.Context);
}
